import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzTableModule } from 'ng-zorro-antd/table';
import { CommonModule } from '@angular/common';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { OperatorsHistoryDashboardComponent } from '../../components/dashboards/operators-history-dashboard/operators-history-dashboard.component';
import { PrismaPerformanceMeterComponent    } from '../../components/dashboards/prisma-performance-meter/prisma-performance-meter.component';
import { PermissionService } from 'src/app/core/services/permission.service';
import { NzIconModule, NzIconService } from 'ng-zorro-antd/icon';
import { IconDefinition } from '@ant-design/icons-angular';
import { UserOutline } from '@ant-design/icons-angular/icons';
import { MachinesDashboardComponent } from '../machines-dashboard/machines-dashboard.component';

const icons: IconDefinition[] = [
    UserOutline,
];

@Component({
    selector: 'app-dashboard',
    standalone: true,
    imports: [
        RouterModule,
        NzMenuModule,
        NzTableModule,
        NzIconModule,
        CommonModule,
        NzLayoutModule,
        OperatorsHistoryDashboardComponent,
        PrismaPerformanceMeterComponent,
        MachinesDashboardComponent
    ],
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
    private readonly iconService = inject(NzIconService);
    private readonly permissionService = inject(PermissionService);

    //Default
    activeTab = signal('operators-history');
    private screenWidth = signal(window.innerWidth);

    constructor() {
        this.iconService.addIcon(...icons);

        window.addEventListener('resize', () => {
            this.screenWidth.set(window.innerWidth);
        });
    }

    setActiveTab(tab: string): void {
        this.activeTab.set(tab);
    }

    isLargeScreen(): boolean {
        return this.screenWidth() >= 1024;
    }

    showButton(btnName: string): boolean {
        const permissionMainKey: string = 'dashboards';
        return  this.permissionService.canRead(permissionMainKey, `${btnName}`); 
    }

    showNavMenuOption(permissionMainKey:string, permissionSubkey: string): boolean {
        return this.permissionService.canRead(permissionMainKey, permissionSubkey);
    }
}
